import { css } from 'linaria';

export const skeletonRow = css`
  display: flex;
  gap: var(--space-150);
  padding: var(--space-100) 0;
`;

export const contentBlock = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-25);
`;

export const skeletonIcon = css`
  flex-shrink: 0;
`;
